export default {"src":"/_next/static/media/dogBone_40.4811d407.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};